import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import DualCalendar from 'Components/DualCalendar';
import DateIcon from 'Components/icons/DateIcon';
import OptionBoxPopup from 'Components/OptionBoxPopup';
import TextField from 'Components/forms/text-field/TextField';

import { getAvailableRanges } from 'Utils/dateUtils';

import '../_ranges.scss';
import '../_datepicker.scss';
import './DualDateInput.scss';

class DualDateInput extends Component {
  constructor(props) {
    super(props);

    this.availableRanges = getAvailableRanges(props.translations);

    const validatedDateFormat = ['MM/DD/YYYY', 'DD/MM/YYYY'].includes(props.dateFormat)
      ? props.dateFormat
      : 'MM/DD/YYYY';

    const triggerText = this.getTriggerText(props.defaultSelect, props.startDate, props.endDate, validatedDateFormat);

    this.state = {
      dateFormat: validatedDateFormat,
      triggerText,
      right: false,
      center: false,
    };

    this.attachBindings();
  }


  componentDidMount() {
    this.setPosition();
  }
  componentWillReceiveProps(newProps) {
    if (newProps.startDate !== this.props.startDate ||
      newProps.endDate !== this.props.endDate ||
      newProps.dateFormat !== this.props.dateFormat || newProps.isDefaultDateSelected) {
      const validatedDateFormat = ['MM/DD/YYYY', 'DD/MM/YYYY'].includes(newProps.dateFormat)
        ? this.props.dateFormat
        : 'MM/DD/YYYY';

      const triggerText = this.getTriggerText(newProps.defaultSelect, newProps.startDate, newProps.endDate, validatedDateFormat);

      this.setState({
        dateFormat: validatedDateFormat,
        triggerText,
      });
    }
  }
  componentWillUpdate(newProps, newState) {
    if (newProps.startDate !== this.props.startDate ||
      newProps.endDate !== this.props.endDate ||
      newProps.dateFormat !== this.props.dateFormat) {
      const validatedDateFormat = ['MM/DD/YYYY', 'DD/MM/YYYY'].includes(newProps.dateFormat)
        ? this.props.dateFormat
        : 'MM/DD/YYYY';
      const triggerText = this.getTriggerText(newProps.defaultSelect, newProps.startDate, newProps.endDate, validatedDateFormat);

      this.setState({
        dateFormat: validatedDateFormat,
        triggerText,
      });
    }
  }

  setPosition = () => {
    const id = this.props.id;
    let el = document.querySelector(`.${id}`);

    let xPos = 0;

    while (el) {
      xPos += (el.offsetLeft - el.scrollLeft + el.clientLeft);
      el = el.offsetParent;
    }
    const halfWindowWidth = window.innerWidth / 3;

    if (xPos > halfWindowWidth && xPos < (halfWindowWidth * 2)) {

      this.setState({
        center: true,
      });
    } else if (xPos > (halfWindowWidth * 2)) {
      this.setState({
        right: true,
      }
      );
    }
  }

  getTriggerText(defaultSelect, start, end, currentFormat) {
    const startOfRange = (this.props.isMerchantUser) ? moment().format(start, currentFormat) : moment(start).format(currentFormat);
    const endOfRange = (this.props.isMerchantUser) ? moment().format(end, currentFormat) : moment(end).format(currentFormat);
    if (defaultSelect) {
      return `${startOfRange} – ${endOfRange}`;
    }
    if (!start && !end) { // start remove to show Select date label in calendar
      return this.props.translations.unselectedText;
    }
    const presetRangeObject = this.availableRanges.find((range) => range.value === start);
    if (presetRangeObject) {
      return presetRangeObject.text;
    }

    if (end) {
      return `${startOfRange} – ${endOfRange}`;
    } else {
      return startOfRange;
    }
  }
  get labelContent() {
    return (
      <span>
        {this.props.title}
        {this.props.error && <span className="message-error">{this.props.error}</span>}
      </span>
    );
  }

  applyChanges() {
    this.child.handleOnSubmit();
  }

  attachBindings() {
    this.applyChanges = this.applyChanges.bind(this);
  }
  render() {
    const htmlId = `${this.props.title.replace(/ /, '-')}-first`;
    const id = `${this.props.id}`;
    const reformatStartDate = this.props.startDate?.includes("-") ? moment(this.props.startDate).format(this.state.dateFormat): this.props.startDate;
    const reformatEndDate = this.props.endDate?.includes("-") ? moment(this.props.endDate).format(this.state.dateFormat): this.props.endDate;
    return (
      <TextField
        error={this.props.error}
        fieldClass={`field range-container dual-date-input ${id}`}
        htmlFor={htmlId}
        labelContent={this.labelContent}
        removeFilterAction={this.props.removeFilterAction}
        showDynamicFilter={this.props.showDynamicFilter}
        updatedId={this.props.updatedId}
      >
        <OptionBoxPopup
          applyAction={this.applyChanges}
          icon={DateIcon}
          translations={this.props.translations}
          triggerText={this.state.triggerText}
          extraClass={this.props.extraClass}
          right={this.state.right}
          center={this.state.center}
        >
          <DualCalendar
            startDate={reformatStartDate}
            endDate={reformatEndDate}
            id={this.props.id}
            onApply={this.props.onApply}
            onRef={(ref) => (this.child = ref)}
            dateFormat={this.state.dateFormat}
            translations={this.props.translations}
            optionalFooter
            right={this.state.right}
            maxDate={this.props.maxDate}
            isArchival={this.props.isArchival}
            isFutureDateDisable={this.props.isFutureDateDisable}
          />
        </OptionBoxPopup>
      </TextField>
    );
  }
}

DualDateInput.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  error: PropTypes.string,
  startDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  endDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  onApply: PropTypes.func.isRequired,
  title: PropTypes.string,
  dateFormat: PropTypes.string,
  translations: PropTypes.object,
  extraClass: PropTypes.string,
  isDefaultDateSelected: PropTypes.bool,
  isArchival: PropTypes.bool,
  isFutureDateDisable: PropTypes.bool,
};

DualDateInput.defaultProps = {
  startDate: '',
  endDate: '',
  error: '',
  title: '',
  dateFormat: 'MM/DD/YYYY',
  extraClass: '',
  defaultSelect: false,
  isDefaultDateSelected: false,
  isFutureDateDisable: false,
  translations: {
    unselectedText: 'Select Date(s)',
    yesterday: 'Yesterday',
    lastSevenDays: 'Last 7 Days',
    lastWeek: 'Last Week',
    lastThirtyDays: 'Last 30 Days',
    lastMonth: 'Last month',
    thisMonth: 'This Month',
    lastYear: 'Last Year',
    thisYear: 'This Year',
    custom: 'Custom',
    from: 'From',
    to: 'To',
    apply: 'Apply',
    cancel: 'Cancel',
    validDateError: 'Please enter a valid date.',
  },
  removeFilterAction: () => { },
  showDynamicFilter: false,
  updatedId: '',
  isArchival: false,
};

export default DualDateInput;
